/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function () {
  const productItemSelector = '.ProductItem';
  let rafId = null;

  const syncProductItemHeights = () => {
    rafId = null;

    const productItems = Array.from(document.querySelectorAll(productItemSelector));
    if (!productItems.length) return;

    let maxHeight = 0;

    productItems.forEach((item) => {
      item.style.minHeight = '';
      maxHeight = Math.max(maxHeight, item.offsetHeight);
    });

    if (!maxHeight) return;

    productItems.forEach((item) => {
      item.style.minHeight = maxHeight + 'px';
    });
  };

  const scheduleSyncProductItemHeights = () => {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(syncProductItemHeights);
  };

  document.addEventListener('DOMContentLoaded', () => {
    scheduleSyncProductItemHeights();
    window.addEventListener('load', scheduleSyncProductItemHeights, { once: true });
    window.addEventListener('resize', scheduleSyncProductItemHeights, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleSyncProductItemHeights);
      document.querySelectorAll(productItemSelector).forEach((item) => observer.observe(item));
    }
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const fallbackMap = {
    '/blogs/news': 'https://bonneetfilou.com/cdn/shop/files/RoyalPromise_1000x.jpg?v=1614290620',
    '/pages/faq': 'https://cdn.shopify.com/s/files/1/0086/6320/3921/files/faq.jpg?v=1746029060',
    '/pages/our-story': 'https://cdn.shopify.com/s/files/1/0086/6320/3921/files/Our_Story_Images.png?v=1619714822',
    '/pages/finest-ingredients': 'https://cdn.shopify.com/s/files/1/0086/6320/3921/files/ingredients_392e38bb-9b7e-459f-a47e-f63c02c64d4b.png',
    '/pages/store-locator': 'https://cdn.shopify.com/s/files/1/0086/6320/3921/files/map.png',
    '/pages/press': 'https://cdn.shopify.com/s/files/1/0086/6320/3921/files/Website_Press_-_Marie_Claire_2a02e0ec-8cff-429d-85f1-da765566b846_2048x2048.png?v=1586676608',
    '/pages/contact-us': 'https://bonneetfilou.com/cdn/shop/t/21/assets/contact-banner.jpg?v=126662815013404357721630428738',
    '/pages/bundle': 'https://cdn.shopify.com/s/files/1/0086/6320/3921/files/Skype_Picture_2021_10_29T15_02_03_516Z.jpg?v=1635519776',
    '/pages/subscription-plan': 'https://cdn.shopify.com/s/files/1/0086/6320/3921/files/MonthlyDogTreatsSubscription_800x_09c248d2-b8da-4d63-89f7-b9c6681b21d9.webp?v=1701274444'
  };

  const mainNav = document.querySelector('.Header__MainNav');
  let activeAnchor = null;
  const localePrefixPattern = /^\/[a-z]{2}(?:-[A-Za-z]{2})?(?=\/)/;

  const normalizePathname = (href) => {
    if (!href) return '';

    try {
      const url = new URL(href, window.location.origin);
      const trimmedPath = url.pathname.replace(/\/+$/, '') || '/';
      return trimmedPath;
    } catch (error) {
      return href.replace(/\/+$/, '');
    }
  };

  const findMenuImageContainer = (anchor) => {
    const megaMenu = anchor.closest('.CMegaMenu');
    if (megaMenu) {
      const menuImage = megaMenu.querySelector('.menuimg');
      if (menuImage) return menuImage;
    }

    const dropdownMenu = anchor.closest('.DropdownMenu');
    if (dropdownMenu) {
      const menuImage = dropdownMenu.querySelector('.menuimg');
      if (menuImage) return menuImage;
    }

    return document.querySelector('.menuimg');
  };

  const clearMenuImage = (menuImageContainer) => {
    if (menuImageContainer) {
      menuImageContainer.innerHTML = '';
    }
  };

  const renderMenuImage = (menuImageContainer, imageUrl, linkText) => {
    if (!menuImageContainer) return;

    if (!imageUrl) {
      clearMenuImage(menuImageContainer);
      return;
    }

    const img = document.createElement('img');
    img.src = imageUrl;
    img.alt = linkText;
    img.loading = 'lazy';
    img.style.width = '200px';
    img.style.height = '200px';
    img.style.objectFit = 'cover';

    menuImageContainer.innerHTML = '';
    menuImageContainer.appendChild(img);
  };

  if (mainNav) {
    // Clear all menu images when mouse leaves the main nav.
    mainNav.addEventListener('mouseleave', function () {
      document.querySelectorAll('.menuimg').forEach(clearMenuImage);
      activeAnchor = null;
    });

    // Handle hover for menu items using event delegation (no jQuery).
    mainNav.addEventListener('mouseover', function (event) {
      const anchor = event.target.closest('a');
      if (!anchor) return;
      if (!anchor.matches('.DropdownMenu li a, .CMegaMenu li a')) return;
      if (anchor === activeAnchor) return;

      activeAnchor = anchor;

      const dataImg = anchor.getAttribute('data-img');
      const href = anchor.getAttribute('href');
      const linkText = anchor.textContent.trim();
      const normalizedPath = normalizePathname(href);
      const normalizedWithoutLocale = normalizedPath.replace(localePrefixPattern, '');
      const imageUrl =
        dataImg ||
        fallbackMap[href] ||
        fallbackMap[normalizedPath] ||
        fallbackMap[normalizedWithoutLocale] ||
        '';
      const menuImageContainer = findMenuImageContainer(anchor);

      renderMenuImage(menuImageContainer, imageUrl, linkText);
    });
  }

  // Tabs still intact
  jQuery('.Product__Tabs_list a').click(function () {
    jQuery('.Product__Tabs_list a').removeClass('activeli');
    jQuery(this).addClass('activeli');
    jQuery('.Collapsible__Inner').removeClass('activetab');
    jQuery('#tab-' + jQuery(this).attr('data-rel')).addClass('activetab');
    return false;
  });
});


$('ul.tabs').each(function(){
  var active, content, links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
    var tabb = $(this).attr('href')
    $(tabb).hide();    
  });
  $(this).find('a').click(function(e){
    active.removeClass('active');
    content.hide().removeClass('active-Table');
    content.find('input[type="radio"]').each(function(){
      $(this).prop('checked', false);
    })
    $('.Selected-val, .all-Properties').empty();
    active = $(this);
    content = $($(this).attr('href'));
    active.addClass('active');
    content.show().addClass('active-Table');
    
    var pr = $('.rc_block.rc_block__type--active input').val();
    var bx = $('.tabs a.active').data('tab');
    
    priceUpdater(pr,bx);
    
    return false;
  });
});

$('ul.tabsinner').each(function(){
  var active, content, links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
    var tabb = $(this).attr('href')
    $(tabb).hide();    
  });
  $(this).find('a').click(function(e){
    active.removeClass('active');
    content.hide();
    active = $(this);
    content = $($(this).attr('href'));
    active.addClass('active');    
    content.fadeIn();
    return false;
  });
});

$('.tabinnerValues').each(function(){
  var option_box = $(this).find('.Selected-val')
  var option = $(this).find('h4').text()
  var all_v = $(this).closest('.option-table').find('.Selected-val')
  $(this).find('input[type="radio"]').click(function(){
    var value = $(this).val()  
    option_box.html("<span>"+ option +': <span class="selected-swatch">'+ value +"</span></span>")   
    var id = $('.no-js.ProductForm__Option select[name="id"]').val()
    option_box.attr('data-id', id)
  })
});

$(document).on('click', '.ProductForm__AddToCart', function(){
  $('.active-Table').find('.Selected-val').each(function(){
    if ($(this).is(':empty')){
      $(this).addClass('ddd')
    }
  })
});

$(document).on('click', '.QuantitySelector__Button', function(){
  var qty = $('.QuantitySelector__CurrentQuantity').val()
  $('.Selected-val').each(function(){
    $(this).attr('data-qty', qty)
  })
})
 
$(document).on('click', '.SizeSwatch__Radio_box3', function(){
  var button = $(this)
  var temp;
  var val = $(this).val();
   $('.active-variant-box-3 option').each(function(){
    if($(this).text() == val){
      temp = $(this).val();
      $('.active-variant-box-3').val(temp);
      setTimeout(function(){
        var getid = $('.active-variant-box-3').val();
        console.log(getid);
        button.closest('.tabinnerValues').find('.Selected-val').attr('data-id',getid ).addClass('active-swatch')
      }, 500);
    }
  })
//   $(this).closest('.tabinnerValues').find('.active-variant-box-3 option').each(function(){
//     if($(this).text() == val){
//       temp = $(this).val();
//     }
//   })
//   $(this).closest('.tabinnerValues').find('.active-variant-box-3').val(temp);
//   setTimeout(function(){
//     var getid = button.closest('.tabinnerValues').find('.active-variant-box-3').val();
//     console.log(getid);
//     button.closest('.tabinnerValues').find('.Selected-val').attr('data-id',getid ).addClass('active-swatch')
//   }, 500);
});

$(document).on('click', '.SizeSwatch__Radio_box5', function(){
  var button = $(this)
  var temp;
  var val = $(this).val();
  $('.active-variant-box-5 option').each(function(){
    if($(this).text() == val){
      temp = $(this).val();
      $('.active-variant-box-5').val(temp);
      setTimeout(function(){
        var getid = $('.active-variant-box-5').val();
        console.log(getid);
        button.closest('.tabinnerValues').find('.Selected-val').attr('data-id',getid ).addClass('active-swatch')
      }, 500);
    }
  })
//   $(this).closest('.tabinnerValues').find('.active-variant-box-5 option').each(function(){
//     if($(this).text() == val){
//       temp = $(this).val();
//     }
//   })
//   $(this).closest('.tabinnerValues').find('.active-variant-box-5').val(temp);
//   setTimeout(function(){
//     var getid = button.closest('.tabinnerValues').find('.active-variant-box-5').val();
//     console.log(getid);
//     button.closest('.tabinnerValues').find('.Selected-val').attr('data-id',getid ).addClass('active-swatch')
//   }, 500);
});

$(document).on('click', '.SizeSwatch__Radio', function(){
  $('.variant_meta_description').hide();
 var title =  $(this).val();

 $('.prodcut-original-select-box option').each(function(){
    //console.log($(this).html());
    if($(this).html() == title ){
      var imageid = $(this).data('image-id'); 
      console.log('.Product__SlideshowNavThumb[data-image-id="'+imageid+'"]');
   $('.Product__SlideshowNavThumb[data-image-id="'+imageid+'"]').parent().trigger('click');
       $('.flickity-page-dots li:eq(4)').trigger('click');
    }
  });
  
  var button = $(this);
  var temp;
  var val = $(this).val();
  
  $('.active-variant option').each(function(){
    if($(this).text() == val){
      temp = $(this).val();
      $('.active-variant').val(temp);
      setTimeout(function(){
        var getid = $('.active-variant').val();
        button.closest('.tabinnerValues').find('.Selected-val').attr('data-id',getid ).addClass('active-swatch');
      }, 500);
    }
  });
//   $(this).closest('.tabinnerValues').find('.active-variant option').each(function(){
//     if($(this).text() == val){
//       temp = $(this).val();
//     }
//   })
//   $(this).closest('.tabinnerValues').find('.active-variant').val(temp);
//   setTimeout(function(){
//     var getid = button.closest('.tabinnerValues').find('.active-variant').val();
//     button.closest('.tabinnerValues').find('.Selected-val').attr('data-id',getid ).addClass('active-swatch')
//   }, 500);

});

$(document).on('click', '.bundle_page .ProductForm__AddToCart-custom', function (e) {
  e.preventDefault();

  const selVal = $('.active-Table').find('.Selected-val').length;
  const activeVal = $('.active-Table').find('.active-swatch').length;

  if (selVal !== activeVal) {
    $('.popup').fadeIn();
    setTimeout(() => {
      $('.popup').fadeOut();
    }, 2000);
    return;
  }

  const qArray = [];

  const buildCartItems = (withSubscription) => {
    $('.active-Table .tabinnerValues').each(function () {
      const qty = $(this).find('.Selected-val').data('qty');
      const id = $(this).find('.Selected-val').data('id');
      
      const item = {
        quantity: qty,
        id: id
      };

      if (withSubscription) {
        const monthVal = $('select[name="properties[shipping_interval_frequency]"]').val();
        item.properties = {
          "shipping_interval_frequency": monthVal,
          "shipping_interval_unit_type": "Months"
        };
      }

      qArray.push(item);
    });
  };

  const isAutodeliver = $('input[value="autodeliver"]').is(':checked');
  buildCartItems(isAutodeliver);

  $.post('/cart/add.js', { items: qArray })
    .done(() => {
      // Instead of redirecting, just refresh cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Some Shopify themes use cart:updated or custom drawer openers too
    });
});

$(document).ready(function () {
  $(document).on('change', '.bundle_page .rc_block [name="purchase_type"]', function () {
    const pr = $('.rc_block.rc_block__type--active input').val();
    const bx = $('.tabs a.active').data('tab');
    priceUpdater(pr, bx);
  });
});

function priceUpdater(purchase, box) {
  const fin = `${purchase}-${box}`;

  $('.update-pagebundles .newpagebundle').hide();
  $(`.update-pagebundles .newpagebundle[data-selector="${fin}"]`).show();
}

// $('.rc_radio__onetime').click(function(){
//   $('.vart-val').addClass('active-variant')
//   $('.vart-val').next().next().next().removeClass('active-variant')
// //   $('.Selected-val').each(function(){
// //     $(this).removeClass('active-swatch').html(' ')
// //   })
//   $('.active-swatch').each(function(){
//     var activeswatch = $(this);
//     var swatch = $(this).find('.selected-swatch').text()
//     var temp;
//     $(this).closest('.tabinnerValues').find('.active-variant option').each(function(){
//       if($(this).text() == swatch){
//         temp = $(this).val();
//       }
//     })
//     $(this).closest('.tabinnerValues').find('.active-variant').val(temp);
//     setTimeout(function(){
//       var value = activeswatch.closest('.tabinnerValues').find('.active-variant').val()
      
//       activeswatch.attr('data-id',value)
//       }, 300);
//   });

// })
/**/

$('a.Button.Button--primary.upperVal').click(function () {
  const tabs = $(this).attr('data-tab');
  const purchaseType = $('input[name="purchase_type"]:checked').val();
  
  if (purchaseType === 'autodeliver') {
    changeSelector(tabs);
  }

  const updatePriceTexts = (oneTime, autoDeliver) => {
    setTimeout(() => {
      $('#rc_price_onetime').text(`${oneTime} per box`);
      $('.rc_price__autodeliver').text(`${autoDeliver} per box`);
    }, 100);
  };

  const toggleBoxes = (showSelector, hideSelectors) => {
    $(showSelector).show();
    hideSelectors.forEach(selector => $(selector).hide());
  };

  const toggleVariants = (showVariant, hideVariants) => {
    $(showVariant).show();
    hideVariants.forEach(variant => $(variant).hide());
  };

  const toggleDescriptions = (showDesc, hideDescs) => {
    $(showDesc).show();
    hideDescs.forEach(desc => $(desc).hide());
  };

  if (tabs === '2-box') {
    updatePriceTexts('$22.49', '$19.12');
    toggleBoxes('.box-2', ['.box-3', '.box-5', '.product-box-3', '.product-box-5']);
    $('.product-original-price').show();
    
    const price = parseFloat($('.product-original-price').attr('data-price').replace('$', '')) || 0;
    const total = (price * 2).toFixed(2);
    
    $('.product-original-price').text(`$${total}`);
    $('.product-compare-price').text('$47.98');
    $('.box-price').text('$22.49');

    toggleVariants('.box-2-variant', ['.box-3-variant', '.box-5-variant']);
    toggleDescriptions('.box-2-desc', ['.box-3-desc', '.box-5-desc']);
  } 
  else if (tabs === '3-box') {
    updatePriceTexts('$21.66', '$18.41');
    toggleBoxes('.box-3', ['.box-2', '.box-5', '.product-box-5']);
    $('.product-box-3').show();
    $('.product-original-price').hide();

    const price = parseFloat($('.product-box-3').attr('data-price').replace('$', '')) || 0;
    const total = (price * 3).toFixed(2);
    
    $('.product-box-3').text(`$${total}`);
    $('.product-compare-price').text('$71.97');
    $('.istbundle-prize').show();
    $('.box-price').text('$21.66');

    toggleVariants('.box-3-variant', ['.box-2-variant', '.box-5-variant']);
    toggleDescriptions('.box-3-desc', ['.box-2-desc', '.box-5-desc']);
  } 
  else if (tabs === '5-box') {
    updatePriceTexts('$19.99', '$16.99');
    toggleBoxes('.box-5', ['.box-2', '.box-3', '.product-box-3']);
    $('.product-box-5').show();
    $('.product-original-price').hide();

    const price = parseFloat($('.product-box-5').attr('data-price').replace('$', '')) || 0;
    const total = (price * 5).toFixed(2);

    $('.product-box-5').text('$99.95');
    $('.product-compare-price').text('$119.95');
    $('.istbundle-prize').show();
    $('.box-price').text('$19.99');

    toggleVariants('.box-5-variant', ['.box-2-variant', '.box-3-variant']);
    toggleDescriptions('.box-5-desc', ['.box-2-desc', '.box-3-desc']);
  }
});

$('.rc_radio__autodeliver').click(function(){
  var tab = $('a.Button.Button--primary.upperVal.active').attr('data-tab');
  console.log(tab);
  changeSelector(tab);
//   $('.Selected-val').each(function(){
//   $(this).removeClass('active-swatch').html(' ')
//   })
});

function changeSelector(tab){

    if(tab == '2-box'){
    $('.vart-val').removeClass('active-variant');
    $("#rc_duplicate_selector-box2").addClass('active-variant');
  	//$('.vart-val').next().next().next().addClass('active-variant');
    $('.active-swatch').each(function(){
      var activeswatch = $(this);
      var swatch = $(this).find('.selected-swatch').text()
      var temp;
      $('.active-variant option').each(function(){
        if($(this).text() == swatch){
          temp = $(this).val();
          console.log(temp);
          $('.active-variant').val(temp);
         // setTimeout(function(){
            var value = $('.active-variant').val()
            console.log(value);
            activeswatch.attr('data-id',$(this).val())
           // }, 300);
            }
          })
    }); 
  }

    else if(tab == '3-box'){
    $('.vart-val').removeClass('active-variant-box-3');
    $("#rc_duplicate_selector-box3").addClass('active-variant-box-3');
    $('.active-swatch').each(function(){
      var activeswatch = $(this);
      var swatch = $(this).find('.selected-swatch').text();
      console.log("swatch "+swatch);
      var temp;
      $('.active-variant-box-3 option').each(function(){
        if($(this).text() == swatch){
          temp = $(this).val();
          console.log("temp "+temp);
          $('.active-variant-box-3').val(temp);
         // setTimeout(function(){
            var value = $('.active-variant-box-3').val()
            console.log("vale " +value);
            activeswatch.attr('data-id',value)
           // }, 300);
              return false;
            }
          })
    });
  }

    else if(tab == '5-box'){
    $('.vart-val').removeClass('active-variant-box-5');
    $("#rc_duplicate_selector-box5").addClass('active-variant-box-5');
    $('.active-swatch').each(function(){
      var activeswatch = $(this);
      var swatch = $(this).find('.selected-swatch').text();
      console.log("swatch "+swatch);
      var temp;
      $('.active-variant-box-5 option').each(function(){
        if($(this).text() == swatch){
          temp = $(this).val();
          console.log("temp "+temp);
          $('.active-variant-box-5').val(temp);
         // setTimeout(function(){
            var value = $('.active-variant-box-5').val()
            console.log("value " +value);
            activeswatch.attr('data-id', value)
           // }, 300);
              return false;
            }
          })
    });
  }
}

var url = window.location.href;
if(url == 'https://bonneetfilou.com/pages/bundle'){
  $('.variant_meta_description').hide();
  $('.box-2-desc').show();
}
setTimeout(function(){ 
$('.Product__SlideshowNavScroller:eq(1)').trigger('click');
  }, 5000);

//Subscription and join now script

document.addEventListener('DOMContentLoaded', function() {
  const joinNowBtn = document.getElementById('join-now-button');

  if (joinNowBtn) {
    joinNowBtn.addEventListener('click', function(event) {
      event.preventDefault();

      const form = document.querySelector('.klaviyo-form');
      if (!form) {
        console.error('Form not found!');
        return;
      }

      if (!(form instanceof HTMLFormElement)) {
        console.error('Selected element is not a form!');
        return;
      }

      const formData = new FormData(form);
      let isValid = true;
      const inputs = form.querySelectorAll('input');

      inputs.forEach(function(input) {
        if (!input.value) {
          isValid = false;
          input.style.borderColor = 'red';
        } else {
          input.style.borderColor = '';
        }
      });

      if (!isValid) {
        alert('Please fill out all fields.');
        return;
      }

      fetch(form.action, {
        method: 'POST',
        body: formData,
      }).then(response => {
        if (response.ok) {
          alert('Subscription successful!');
          window.location.href = "https://bonneetfilou.com/tools/recurring/checkout_link?magic=eyJpdGVtcyI6IFt7ImlkIjogNDQ4Mjc0MTkxNDg1MzAsICJxdWFudGl0eSI6IDEsICJzZWxsaW5nX3BsYW4iOiA0OTUyMTI5Nzc4LCAic2VsbGluZ19wbGFuX2lkIjogMTA3OTk2Nzk4Nn1dfQ==&store_id=88103";
        } else {
          alert('Subscription failed. Please try again.');
        }
      }).catch(error => {
        console.error('An error occurred:', error);
        alert('An error occurred. Please try again.');
      });
    });
  } else {
    console.warn('#join-now-button not found on the page.');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  const cartDrawer = document.getElementById('sidebar-cart');

  addToCartForms.forEach((form) => {
    form.addEventListener('submit', function (event) {
      event.preventDefault(); // Prevent the default form submission

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to add item to cart');
          }
          return response.json();
        })
        .then((data) => {
          console.log('Item added to cart:', data);
          openCartDrawer(); // Open the cart drawer
        })
        .catch((error) => {
          console.error('Error adding item to cart:', error);
        });
    });
  });

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.setAttribute('aria-hidden', 'false');
      cartDrawer.classList.add('Drawer--open');
    }
  }
});

document.addEventListener('cart:refresh', function () {
  const cartDrawer = document.getElementById('sidebar-cart');

  if (cartDrawer) {
    // Fetch latest cart HTML to update drawer content
    fetch('/cart?view=drawer')
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const drawerContent = doc.querySelector('.Drawer__Content');

        if (drawerContent) {
          cartDrawer.querySelector('.Drawer__Content').innerHTML = drawerContent.innerHTML;
        }

        // Open drawer
        cartDrawer.classList.add('is-open');
        cartDrawer.setAttribute('aria-hidden', 'false');
      });
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const headers = document.querySelectorAll(".accordion-header");

  headers.forEach(header => {
    const content = header.nextElementSibling;
    const icon = header.querySelector(".icon");

    if (!content) return;
    content.style.display = "block";
    header.setAttribute("aria-expanded", "true");
    if (icon) {
      icon.textContent = "-";
    }

    header.addEventListener("click", function () {

      const content = this.nextElementSibling;
      const icon = this.querySelector(".icon");
      const isOpen = window.getComputedStyle(content).display !== "none";

      if (isOpen) {
        content.style.display = "none";
        this.setAttribute("aria-expanded", "false");
        if (icon) {
          icon.textContent = "+";
        }
      } else {
        content.style.display = "block";
        this.setAttribute("aria-expanded", "true");
        if (icon) {
          icon.textContent = "-";
        }
      }

    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-action="toggle-collapsible-multiple"]');
    if (!trigger) return;

    const parentCollapsible = trigger.closest('.Collapsible');
    if (!parentCollapsible) return;

    const collapsibleInner = parentCollapsible.querySelector('.Collapsible__Inner');
    if (!collapsibleInner) return;

    const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    collapsibleInner.classList.toggle('activetab', shouldOpen);
    event.preventDefault();
  });
});
